module.exports = __webpack_public_path__ + "img/bogota.938e85f0.jpg";